import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://ycmiptlsoqaldzwxhphe.supabase.co'
const supabaseKey = 'sb_publishable_MKihP9w9e5QpGvLvZwqSag_I_TTCE2A'
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  global: {
    fetch: (url, options = {}) => fetch(url, { ...options, cache: 'no-store' }),
  },
})
